'use client';

import { SiteHome, SiteHomeInput } from "@/app/lib/generated/graphql-types";
import { createContext, ReactNode, useContext } from "react";
import LoadingSpinner from "@/app/__to_be_integrated/_____components/_NEW/LoadingSpinner";
import {
    SiteHomeEditable,
    SiteHomeSchema
} from "@/app/features/sites/home/types/form-data/SiteHome.schema";
import { updateSiteHome } from "@/app/features/sites/home/data-access/mutations";
import { useSingleTypeEditor, UseSingleTypeEditorType } from "@/app/lib/hooks/use-editor/useSingleTypeEditor";
import { getHomeSite } from "@/app/features/sites/home/data-access/queries";
import FloatingEditorMenu from "../../../shared/__to_be_integrated/FloatingEditorMenu";
import { toggleDraftMode } from "@/app/lib/actions/editing";


const HomeContext = createContext<UseSingleTypeEditorType<SiteHomeEditable> | undefined>(undefined);

export function useHomeEditor() {
    const context = useContext(HomeContext);
    if (!context) {
        throw new Error("useHomeEditor must be used within a HomeProvider");
    }
    return context;
}

interface HomeProviderProps {
    children: ReactNode;
    isDraftModeEnabled: boolean;
}

export default function HomeProvider({ children, isDraftModeEnabled }: HomeProviderProps) {
    const editor = useSingleTypeEditor<SiteHome, SiteHomeEditable, SiteHomeInput>({
        schema: SiteHomeSchema,
        loadEntity: getHomeSite,
        update: updateSiteHome,
        // toInput: siteHomeInputFrom,
        // toEditable: editableSiteHomeFrom,
        revalidateTags: ['home'],
    })

    if (editor.isLoading) return <LoadingSpinner />

    return (
        <HomeContext.Provider value={editor}>
            {children}
            <FloatingEditorMenu
                autosaveState={editor.autosaveState || undefined}
                isDraftModeEnabled={isDraftModeEnabled}
                toggleDraftMode={toggleDraftMode}
                hasChanges={editor.hasChanges}
                onPublish={editor.publish}
                onDiscard={editor.discardChanges}
            />
        </HomeContext.Provider>
    )
}
